import React, { ReactNode } from 'react'
import {
    // ETH_SWAP_MAX_ALLOWED,
    // ETH_TO_DAI_SWAP_MAX_ALLOWED,
    // ETH_TO_USDT_SWAP_MAX_ALLOWED,
    // ETH_TOKEN_ADDRESS,
    // DAI_TOKEN_ADDRESS,
    // USDT_TOKEN_ADDRESS,
    getWalletTokenAmount
} from '../../services/amm'
import Balance from './../Balance'
import Select from './Select'
import { formatNumber, getTokenUSDPrice } from '../../blockchainUtils/math'
import { useStoreState } from '../../model/hooks'
import { getTokenBraavosName } from '../../blockchainUtils'
import { Token } from '../../atoms'
import { getToken } from '../../model/tokens/helper'

// ETH, STRK, USDC, USDT, WBTC, wstETH, DAI
export const TOKENS_ORDER: Record<string, number> = { ETH: 0, STRK: 1, USDC: 2, WBTC: 3, wstETH: 4, DAI: 5, USDT: 6 }
export function tokenOrder(key_and_token: any) {
    const tokenSym = key_and_token.symbol
    return TOKENS_ORDER[tokenSym] ?? 100
}

function TokenSelectorNew(props: {
    tokenAmount: string
    inputs: ReactNode
    error: string
    token: any
    tokenStr: any
    otherToken: string
    network: string
    tokens: any
    handleTokenSelect: any
    showMaxButton: boolean
    handleTokenAmountChange: any
    isSelectDisabled?: boolean
    size?: 'sm' | 'md'
    setIsMaxBalance?: (isMax: boolean) => void
}) {
    const { handleTokenAmountChange, handleTokenSelect, network, otherToken, showMaxButton, token, isSelectDisabled = false, size = 'md', setIsMaxBalance } = props
    const tokenObject = network && props.token ? (getToken(network, props.token) as unknown as Token) : ({} as Token)
    const price = useStoreState((store) => store.pricing.getPrice(getTokenBraavosName(tokenObject ? tokenObject.symbol : '')))
    const tokens = useStoreState((state) => state.tokens.getTokensList(network))

    function sortTokens() {
        const toks = tokens.map((a) => {
            return { ...a }
        })
        toks.sort((e1, e2) => {
            return tokenOrder(e1) - tokenOrder(e2)
        })
        return toks
    }

    function getSortedList() {
        let tokensList: any = [...sortTokens()]
        const list: Token[] = []
        tokensList.forEach((value: any) => {
            const address = value.address
            if (otherToken !== address) {
                list.push(value)
            }
        })
        return list
    }

    // const ethMaxAllowed = () => {
    //     if (token !== ETH_TOKEN_ADDRESS) return undefined

    //     if (otherToken === DAI_TOKEN_ADDRESS) return ETH_TO_DAI_SWAP_MAX_ALLOWED
    //     if (otherToken === USDT_TOKEN_ADDRESS) return ETH_TO_USDT_SWAP_MAX_ALLOWED
    //     return ETH_SWAP_MAX_ALLOWED
    // }

    return (
        <div className='flex-col w-full'>
            <div className='flex w-full'>
                <div className={`relative shrink-0 ${token ? '' : 'w-full'} pr-4`}>
                    <div className='w-full flex relative flex-col max-w-[158px]'>
                        <Select
                            size={size}
                            isDisabled={isSelectDisabled}
                            network={network}
                            onSelect={handleTokenSelect}
                            placeholder={'Select Token'}
                            selectedValue={token}
                            options={getSortedList() as any}
                        />
                    </div>
                </div>
                <div className='w-full'>{props.inputs}</div>
            </div>
            <div className='flex w-full justify-between items-center'>
                <Balance
                    setIsMaxBalance={(isMax) => {
                        setIsMaxBalance ? setIsMaxBalance(isMax) : {}
                    }}
                    isSelectDisabled={isSelectDisabled}
                    token={token}
                    amount={token ? getWalletTokenAmount(network, token) : undefined}
                    showMaxButton={showMaxButton}
                    setMaxAmountHandler={handleTokenAmountChange}
                    // eth_max_allowed={ethMaxAllowed()}
                />
                {props.error ? (
                    <span className='text-[#FF3D3D] text-xs min-w-[150px] text-right lg:text-[16px] font-bold'>{props.error}</span>
                ) : (
                    <span className='text-right text-[14px] text-gray font-normal	'>{`$${formatNumber(
                        Number(getTokenUSDPrice(props.tokenAmount ? Number(props.tokenAmount) : 0, price ? price.usd : 0))
                    )}`}</span>
                )}
            </div>
        </div>
    )
}

export default TokenSelectorNew
